export function formatnumber(num) {
    try {
        if (num >= 1_000_000_000) {
            return (num / 1_000_000_000).toFixed(num % 1_000_000_000 === 0 ? 0 : 1) + 'B';
        } else if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 1) + 'M';
        } else if (num >= 1_000) {
            return (num / 1_000).toFixed(num % 1_000 === 0 ? 0 : 1) + 'K';
        } else {
            return num.toString();
        }
    } catch (error) {
        return ""
    }
}

export function formatDate(isoString) {


    try {

        const date = new Date(isoString);
        const options = {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            timeZone: 'UTC' // Optional: Remove or set to local timezone if needed
        };

        // Format the date
        return new Intl.DateTimeFormat('en-GB', options)
            .format(date)
            .replace(',', ''); // Remove comma between date and time if needed
    } catch (error) {
        return ''
    }

}

export function getDateOnly(isoString) {
    try {


        const date = new Date(isoString);
        return new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            timeZone: 'UTC' // Optional: Remove for local time
        }).format(date);
    } catch (error) {
        return ''
    }

}

export function getTimeOnly(isoString) {
    try {


        const date = new Date(isoString);
        return new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            timeZone: 'UTC' // Optional: Remove for local time
        }).format(date);
    } catch (error) {
        return ''
    }
}
